import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/content";
import { PageIntro } from "../components/PageIntro";

const FaqRow = ({ item, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-ink" data-testid={`faq-item-${index}`}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={`faq-toggle-${index}`}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-6 py-7 text-left"
      >
        <span className="flex items-baseline gap-5">
          <span className="font-mono text-xs text-terracotta">{String(index + 1).padStart(2, "0")}</span>
          <span className="text-xl font-medium tracking-tight md:text-2xl">{item.q}</span>
        </span>
        <span className="shrink-0 transition-colors duration-300" aria-hidden>
          {open ? <Minus className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-2xl pb-8 pl-0 text-lg font-normal leading-relaxed text-ink/70 md:pl-11">
              {item.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageIntro
        label="FAQ"
        titleLines={["Frequently", "Asked", "Questions"]}
        blurb="If it's not here, call us. We'd rather tell you plainly."
      />

      <section className="mx-auto max-w-[1100px] px-5 md:px-10" data-testid="faq-list">
        <div className="border-t border-ink">
          {FAQS.map((item, i) => (
            <FaqRow key={i} item={item} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
